import { gql } from "@grandvisionhq/graphql";
const SUBSCRIBE_NEWSLETTER_OPT_IN = gql`
  mutation SubscribeNewsletterOptIn($input: SubscribeNewsletterInput!) {
    subscribeNewsletter(input: $input) {
      __typename
      success
    }
  }
`;
export {
  SUBSCRIBE_NEWSLETTER_OPT_IN
};
//# sourceMappingURL=subscribe-newsletter-opt-in.js.map
